// components/QuestionsPopup.js
import React, { useEffect, useState } from "react";
import adminAxios from "../../config/adminAxios";
import {
  Box,
  Button,
  Layer,
  Table,
  TableHeader,
  TableRow,
  TableCell,
  TableBody,
  Text,
  Spinner,
  Notification,
} from "grommet";
import AddQuestionsModal from "./AddQuestionsModal";

const QuestionsPopup = ({
  courseId,
  onClose,
  courseName,
  portfolio_id, // ← you'll need to pass this in from the parent
}) => {
  const [questions, setQuestions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showToast, setShowToast] = useState(false);

  useEffect(() => {
    const fetchQuestions = async () => {
      try {
        setIsLoading(true);
        const res = await adminAxios.get(`/api/admin/courses/${courseId}/questions`);
        const body = res.data;
        setQuestions(body.questions || []);
      } catch (err) {
        setError(err.message);
      } finally {
        setIsLoading(false);
      }
    };
    fetchQuestions();
  }, [courseId]);

  const handleAdded = (newQuestions) => {
    // Merge them into your table
    setQuestions((prev) => [...prev, ...newQuestions]);
    setShowAddModal(false);
    setShowToast(true);
    setTimeout(() => setShowToast(false), 2000);
  };

  return (
    <>
      <Layer onEsc={onClose} onClickOutside={onClose}>
        <Box
          pad="medium"
          gap="medium"
          width="xlarge"
          maxHeight="70vh"
          overflow="auto"
        >
          <Box direction="row" justify="between" align="center">
            <Text weight="bold" size="large">
              Questions for Course - {courseName}
            </Text>
            <Button label="Close" onClick={onClose} />
          </Box>

          {isLoading ? (
            <Box align="center" pad="medium">
              <Spinner />
            </Box>
          ) : error ? (
            <Text color="status-critical">Error: {error}</Text>
          ) : questions.length === 0 ? (
            <Box align="center" pad="medium">
              <Text>No questions found for this course.</Text>
              <Button
                margin={{ top: "small" }}
                primary
                label="Add Questions"
                onClick={() => setShowAddModal(true)}
              />
            </Box>
          ) : (
            <>
              <Box overflow="auto">
                <Table>
                  <TableHeader>
                    <TableRow>
                      <TableCell>
                        <Text>Question</Text>
                      </TableCell>
                      <TableCell>
                        <Text>Type</Text>
                      </TableCell>
                    </TableRow>
                  </TableHeader>
                  <TableBody>
                    {questions.map((q) => (
                      <TableRow key={q.id || q.question_id}>
                        <TableCell>
                          <Text>{q.question}</Text>
                        </TableCell>
                        <TableCell>
                          <Text>{q.weight === 2 ? "Range" : "Yes/No"}</Text>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
              <Box align="end" margin={{ top: "small" }}>
                <Button
                  label="Add More Questions"
                  onClick={() => setShowAddModal(true)}
                  secondary
                />
              </Box>
            </>
          )}
        </Box>
      </Layer>

      {showToast && (
        <Notification
          toast
          status="normal"
          message="Questions added successfully"
          onClose={() => setShowToast(false)}
        />
      )}

      {showAddModal && (
        <AddQuestionsModal
          open={showAddModal}
          onClose={() => setShowAddModal(false)}
          portfolioId={portfolio_id}
          courseId={courseId}
          courseName={courseName}
          existingQuestionIds={questions.map((q) => q.id || q.question_id)}
          onAdded={handleAdded}
        />
      )}
    </>
  );
};

export default QuestionsPopup;
